import { Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MappingTable } from '../../../shared/interfaces/mapping-table.interface';
import { MultiLanguageService } from '../../../parts/multi-language/multi-language.service';
import { ConfigurationHandlerService } from '../../../core/configuration-handler.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';


@Component({
    selector: 'esp-cv-format',
    templateUrl: './cv-format.component.html',
    styleUrls: ['./cv-format.component.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption,
        TranslateModule
    ]
})
export class CvFormatComponent implements OnInit {
    private fb = inject(FormBuilder);
    private multiLanguageService = inject(MultiLanguageService);
    private configurationHandlerService = inject(ConfigurationHandlerService);

    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() form: FormGroup;
    languages: { twoLetterCode: string; threeLetterCode: string }[] = [];

    constructor() {
        const fb = this.fb;

        this.form = fb.group({ format: null, language: null });
    }

    ngOnInit(): void {
        const institutionLanguagesMT =
            this.configurationHandlerService.getMappingTable(
                'esploro_InstitutionLanguages'
            ) as MappingTable[];
        this.languages = institutionLanguagesMT
            .filter((row) => row.source2 === 'true' && row.enabled === 'true')
            .map((row) => {
                return {
                    twoLetterCode: row.target,
                    threeLetterCode: this.multiLanguageService.get3CharLanguage(
                        row.target
                    ),
                };
            });
    }
}
